import React, {Component} from 'react';
import {ExternalLink} from "../../components/helpers/EasyLinks";
import FA from "react-fontawesome";

export class SponsorView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            html: {__html: ''},
            isLoading: false,
            hasErred: false
        };
        this.fetchHtml = this.fetchHtml.bind(this)
    }

    fetchHtml(url) {
        this.setState({isLoading: true});
        window.setTimeout(() =>
            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    this.setState({isLoading: false});
                    return response;
                })
                .then((response) => response.text())
                .then((html) => this.setState({html: {__html: html}}))
                .catch(() => this.setState({hasErred: true})), 500);
    }

    componentDidMount() {
        this.fetchHtml(this.props.htmlUrl);
    }

    render() {
        const {group, company, url, imageUrl, list} = this.props;
        return <div className={group + (list ? '' : ' text-center')}>
            {!list && <h1>{group.name}</h1>}
            <ExternalLink link={url}><img className={(list ? 'pull-right ' : '') + "sponsor organizer"} src={imageUrl} alt={company}/></ExternalLink>
            {list && <h3><ExternalLink link={url}>{company}</ExternalLink></h3>}
            {!this.state.isLoading && <div className={"text-left "+(list ? '':'lead')} dangerouslySetInnerHTML={this.state.html}/>}
            {this.state.isLoading && <div><FA name="spinner" spin/></div>}
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/components/sponsors/SponsorView.js